export default Object.freeze({
  3: {
    scalp_type: 'OILY',
    product_id: 3,
    product_variations: {
      main: 3,
      sampler:
        process.env.REACT_APP_BASE_URL === 'https://stg.becon-api.com'
          ? 16
          : 15,
    },
    category: 'SHAMPOO',
    blending_labels_kr: [
      '강력한 세정력',
      '저자극 쿨링감',
      '뾰루지 케어',
      '각질, 피지 케어',
      '비듬, 염증 케어',
    ],
    blending_levels: [5, 4, 4, 4, 3],
    picked: false,
    selectedKitProduct: false,
  },
  4: {
    scalp_type: 'GENERAL',
    product_id: 4,
    product_variations: {
      main: 4,
      sampler:
        process.env.REACT_APP_BASE_URL === 'https://stg.becon-api.com'
          ? 17
          : 16,
    },
    category: 'SHAMPOO',
    blending_labels_kr: [
      '강력한 세정력',
      '보습, 항산 케어',
      '천연 쿨링감',
      '두피 진정',
      '비듬, 염증 케어',
    ],
    blending_levels: [4, 3, 3, 3, 3],
    picked: false,
    selectedKitProduct: false,
  },
  8: {
    scalp_type: ['DRY', 'SENSITIVITY'],
    product_id: 8,
    product_variations: { main: 10, sampler: 18 },
    category: 'SHAMPOO',
    blending_labels_kr: [
      '천연 세정력',
      '강력한 세정력',
      '보습, 항산 케어',
      '두피 진정',
      '비듬, 염증 케어',
    ],
    blending_levels: [4, 2, 5, 4, 3],
    picked: false,
    selectedKitProduct: false,
  },
  11: {
    scalp_type: 'SEBORRHEIC',
    product_id: 11,
    product_variations: { main: 14, sampler: 19 },
    category: 'SHAMPOO',
    blending_labels_kr: [
      '천연 세정력',
      '강력한 세정력',
      '천연 쿨링감',
      '피부 재생',
      '비듬, 염증 케어',
    ],
    blending_levels: [4, 3, 3, 3, 5],
    picked: false,
    selectedKitProduct: false,
  },
  5: {
    product_id: 5,
    product_variations: {
      main: 5,
      sampler:
        process.env.REACT_APP_BASE_URL === 'https://stg.becon-api.com'
          ? 20
          : 17,
    },
    category: 'TREATMENT',
    blending_levels: [4, 5, 5, 4],
    picked: false,
    selectedKitProduct: false,
  },
  2: {
    product_id: 2,
    product_variations: { main: 2, sampler: 2 },
    category: 'AMPLE',
    picked: false,
    selectedKitProduct: false,
  },
  1: {
    product_id: 1,
    product_variations: { main: 1, sampler: 1 },
    category: 'ESSENCE',
    picked: false,
    selectedKitProduct: false,
  },
});

// 결과페이지 샴푸 성분 정보
const SHAMPOO_INGREDIENTS = Object.freeze({
  3: {
    ingredients: [
      {
        color: '#d2eaf9',
        key: '강력하고 건강한 세정의 일반 음이온',
        value: '소듐C14-16올레핀설포네이트',
      },
      {
        color: null,
        key: '유분 많은 피부의 항균을 위한 양쪽성 음이온',
        value: '라우릴하이드록시설테인, 라우릴베타인',
      },
      {
        color: '#ffffff',
        border: '#cecece',
        key: '지성두피의 답답함을 날릴 쿨링+',
        value: '엘-멘톨 x 2',
      },
      {
        color: '#744b49',
        key: '특별한 각질 케어를 위한 BHA, LHA, PHA의 조합',
        value:
          '흰버드나무껍질추출물 (BHA), 카프릴로일살리실릭애씨드 (LHA), 락토바이오닉애씨드 (PHA)',
      },
      {
        color: '#bc4231',
        key: '피지와 뾰루지 케어가 필수적인 지성두피를 위한',
        value: '대왕송잎추출물, 당느릅나무뿌리추출물',
      },
    ],
  },
  4: {
    ingredients: [
      {
        color: '#d2eaf9',
        key: '식물유래성분이지만 강한 세정력',
        value: '다이소듐라우레스설포석시네이트',
      },
      {
        color: '#cbdaf0',
        key: '두피케어의 기본인 항산과 보습을 위한',
        value: '리치과피추출물, 토코페롤, 덱스판테놀',
      },
      {
        color: '#ffffff',
        key: '세정 후에도 시원함을 제공할',
        value: '엘-멘톨, 멘틸에틸아미도옥살레이트',
      },
      {
        color: '#bc4231',
        key: '염증 및 각질 케어를 위한',
        value: '피록톤올아민, 카프릴로일살리실릭애씨드',
      },
    ],
  },
  8: {
    ingredients: [
      {
        color: '#d2eaf9',
        key: '라멜렉스 기술의 부드러운 천연 음이온',
        value: '소듐코코일알라니네이트, 코코-글루코사이드',
      },
      {
        color: '#cbdaf0',
        key: '건조한 두피에 보습을',
        value: '펜틸렌글라이콜, 솔비톨',
      },
      {
        color: null,
        key: '강력한 항산화로 두피에 영양을',
        value: '토코페롤',
      },
      {
        color: '#fdec9b',
        key: '가려운 두피 진정을 위한',
        value: '병풀추출물, 당근추출물',
      },
    ],
  },
  11: {
    ingredients: [
      {
        color: '#d2eaf9',
        key: '항균력이 있는 충분한 세정력의 천연 음이온',
        value: '다이소듐라우레스설포석시네이트, 코코-베타인',
      },
      {
        color: '#8f2516',
        key: '강력한 항지루성 케어',
        value: '피록톤올아민 x 2',
      },
      {
        color: null,
        key: '염증 케어 및 피부 진정',
        value: '마데카소사이드, 맥아추출물',
      },
      {
        color: '#99dbc5',
        key: '피부 재생 및 활력',
        value: '덱스판테놀, 다이프로필렌글라이콜',
      },
    ],
  },
});

export { SHAMPOO_INGREDIENTS };
